import YouTubeLightbox from './YouTubeLightbox';

export default YouTubeLightbox;
